import {isPresetEvent} from './quick-effects';
import type {
  EventsType,
  InteractionId,
  InteractionsType,
} from '@packages/systems/ix2/types-core';

/**
 * Returns true if the 2 sets share at least 1 element
 */
function sharesElement<T>(set1: Set<T>, set2: Set<T>): boolean {
  for (const key of set1.keys()) {
    if (set2.has(key)) {
      return true;
    }
  }
  return false;
}

export function pageUsesIx2(
  pageId: string,
  events: EventsType = [],
  actionLists: InteractionsType = [],
  symbolIds: Set<string>,
  styleIds: Set<string>
): boolean {
  // Create a Set of action list ids for quick lookup.
  const actionListSet = new Set<InteractionId>(
    actionLists.map((actionList) => actionList.id)
  );

  // Iterate through events
  for (const event of events) {
    // Check if event has media queries
    if (event?.mediaQueries?.length > 0) {
      // Check if the event target is relevant to this page
      const targetBlock = event.target;
      let match = false;
      if (targetBlock) {
        switch (targetBlock.appliesTo) {
          case 'PAGE':
          case 'ELEMENT': {
            const targetId = targetBlock.id?.split('|')[0] ?? '';
            match = targetId === pageId || symbolIds.has(targetId);
            break;
          }
          case 'CLASS': {
            const eventStyleIds = new Set(event.target?.styleBlockIds ?? []);
            match = sharesElement(styleIds, eventStyleIds);
            break;
          }
        }
      }
      if (match && event.action && isPresetEvent(event)) {
        return true; // Quick effect events are always included
      }
      // Check if the event has an associated action list
      const actionListId = event.action?.config?.actionListId ?? '';
      if (match && actionListSet.has(actionListId)) {
        return true; // Event with a valid action list should be included
      }
    }
  }

  // No valid events found for this page
  return false;
}
